import { CustomFieldModalStore } from 'entities/CustomField/ui/CustomFieldModal/store/CustomFieldModalStore'

export const createCustomFieldAction = (onSuccess: () => Promise<void>) => {
  new CustomFieldModalStore({ onSuccess })
}
